var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.05 323.47",
    style: {
      enableBackground: "new 0 0 210.05 323.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED0F0F;}\r\n\t.st1{opacity:0.39;fill:#CB2227;}\r\n\t.st2{fill:#F76666;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.03,0C47.02,0,0,47.02,0,105.03s57.29,142.06,105.03,218.44c50.05-80.43,105.03-160.44,105.03-218.44 S163.03,0,105.03,0z M105.03,155.24c-27.72,0-50.2-22.47-50.2-50.2s22.47-50.2,50.2-50.2s50.2,22.47,50.2,50.2 S132.75,155.24,105.03,155.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.24,266.44c16.19,25.96,22.92,36.44,35.78,57.02c50.05-80.43,105.03-160.44,105.03-218.44 C210.05,105.03,181.66,182.18,69.24,266.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.88,111.07c0-47.47,38.48-85.94,85.94-85.94c24.73,0,47,10.46,62.68,27.17 c-16.1-21.96-42.07-36.22-71.38-36.22c-48.86,0-88.47,39.61-88.47,88.47c0,38.3,24.34,70.91,58.4,83.22 C43.07,173.59,23.88,144.58,23.88,111.07z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.03f02aab46ea8abaee20c6a9fe5d5efc.svg";
export { ForwardRef as ReactComponent };